import React, { useState } from "react";
import { Link, LinkProps, useLocation, useNavigate } from "react-router-dom";
import Box from "@mui/material/Box";
import Tabs from "@mui/material/Tabs";
import Tab, { TabProps } from "@mui/material/Tab";
import { AppState } from "../../AppState/appState";
import { useDispatch, useSelector } from "react-redux";

import { FooterTabPosition } from "../../AppState/footerTabPosition";
import CustomDialog from "../confirmationPopup/confirmationPopup";
import { AppURLs, ETab } from "../../constants";
import usePermissions from "../../@hooks/usePermissions";

const Footer = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const currentTabPosition = useSelector(
    (state: AppState) => state.tabPosition,
  );

  const isFormValueChanged = useSelector(
    (state: AppState) => state.isFormValueChanged,
  );

const permissions = usePermissions();

  const [dialogOpen, setDialogOpen] = useState(false); // State to manage dialog open/close
  const [navigationPath, setNavigationPath] = useState(""); // State to manage dialog open/close
  const [previousTab, setPreviousTab] = useState(currentTabPosition); // State to manage dialog open/close

  const LinkTab: React.ComponentType<TabProps & LinkProps> =
    Tab as React.ComponentType<TabProps & LinkProps>;

  const tabOnChange = (_event: React.SyntheticEvent, value: number) => {
    setPreviousTab(currentTabPosition);
    dispatch(FooterTabPosition(value));
  };

  const onTabClick = (e: any, navigateTo: string) => {
    e.preventDefault();
    setNavigationPath(navigateTo);
    if (location.pathname.includes("/entry") && isFormValueChanged) {
      setDialogOpen(true);
    } else {
      navigate(navigateTo);
    }
  };
  // Close the confirmation modal pop and navigate user to back overage listing page if user confirmed
  const handleDialogClose = (flag?: string) => {
    setDialogOpen(false);
    if (flag === "yes") {
      navigate(navigationPath);
    } else {
      dispatch(FooterTabPosition(previousTab));
    }
  };

  return (
    <div>
      {[ETab.maintenance, ETab.unauthorized].includes(
        currentTabPosition,
      ) ? null : (
        <>
          <Box sx={{ width: "100%" }}>
            <Tabs
              value={currentTabPosition}
              onChange={tabOnChange}
              variant="scrollable"
              scrollButtons="auto"
              allowScrollButtonsMobile
              aria-label="nav tabs example"
            >
              <LinkTab
                onClick={(e) => {
                  onTabClick(e, AppURLs.dashboard);
                }}
                label="Dashboard"
                LinkComponent={Link}
                to={AppURLs.dashboard}
              />
              <LinkTab
                onClick={(e) => {
                  onTabClick(e, AppURLs.myAssignments);
                }}
                label="My Assignment"
                LinkComponent={Link}
                to={AppURLs.myAssignments}
              />
              <LinkTab
                className={permissions.overages ? "" : "hide-me-tab"}
                onClick={(e) => {
                  onTabClick(e, AppURLs.overages);
                }}
                label="Overages"
                LinkComponent={Link}
                to={AppURLs.overages}
              />
              <LinkTab
                className={permissions.shortages ? "" : "hide-me-tab"}
                onClick={(e) => {
                  onTabClick(e, AppURLs.shortages);
                }}
                label="Shortages"
                LinkComponent={Link}
                to={AppURLs.shortages}
              />
              <LinkTab
                className={permissions.damages ? "" : "hide-me-tab"}
                onClick={(e) => {
                  onTabClick(e, AppURLs.damages);
                }}
                label="Damages / Refusals"
                LinkComponent={Link}
                to={AppURLs.damages}
              />
              <LinkTab
                className={permissions.onHandDelivery ? "" : "hide-me-tab"}
                onClick={(e) => {
                  onTabClick(e, AppURLs.onHandDelivery);
                }}
                label="On Hand"
                LinkComponent={Link}
                to={AppURLs.onHandDelivery}
              />
              <LinkTab
                className={permissions.misDelivery ? "" : "hide-me-tab"}
                onClick={(e) => {
                  onTabClick(e, AppURLs.misdelivery);
                }}
                label="Misdelivery"
                LinkComponent={Link}
                to={AppURLs.misdelivery}
              />
              <LinkTab
                className={permissions.cleared ? "" : "hide-me-tab"}
                onClick={(e) => {
                  onTabClick(e, AppURLs.cleared);
                }}
                label="Cleared"
                LinkComponent={Link}
                to={AppURLs.cleared}
              />
            </Tabs>
          </Box>
          <CustomDialog open={dialogOpen} onClose={handleDialogClose} />
        </>
      )}
    </div>
  );
};

export default Footer;
